<template>
<div class="input__wrapper">
 <button class="addListItem innerBtn" @click="handleAddListItem">+ List Item</button>
       <div class="ListItem" v-for="listItem in list" :key="listItem.id">
            <PopListItem :listItem="listItem" />
        </div>
   <DeleteButton :index="index" />
</div> 
</template>

<script setup>
import DeleteButton from '@/components/PopUp/DeleteButton.vue'
import { fieldFactory } from '@/helper/popFieldFactory';
import PopListItem from '@/components/PopUp/PopListItem.vue'
import { nanoid } from 'nanoid'
import { toRaw } from 'vue';
const props = defineProps({
    popStoreId:String,
     index:Number
})

const list = fieldFactory('list', props.popStoreId)

const handleAddListItem = () => {
    const id = nanoid(10)
    list.value = [...toRaw(list.value), {id}]
}

</script>

<style>

</style>